import type { VoidFunctionComponent } from 'react';

import { BadgeColors, TooltipContent } from '../../../generic';
import TooltipBadge from '../../../generic/Badge/TooltipBadge';

type Props = {
  showTooltip?: boolean;
};

/**
 * Displays a known exploit badge.
 */
const KnownExploitBadge: VoidFunctionComponent<Props> = ({ showTooltip = true }) => (
  <TooltipBadge
    id="cve-badge"
    tooltip={<TooltipContent>Exploit maturity</TooltipContent>}
    showTooltip={showTooltip}
    color={BadgeColors.DarkGray}
  >
    Exploit known
  </TooltipBadge>
);

export default KnownExploitBadge;
